import { useViewedVehicle } from 'pages/Admin/ViewVehicle/hooks/useViewedVehicle';
import { InfoBlock } from '../../InfoBlock';
import { PullVehicleControls } from './PullVehicleControls';
import styled from 'styled-components';
import { OfferAuctionStatus, Vehicle } from 'types/vehicle';
import { HighestBid } from './AdminActions/HighestBid';
import { AcceptHighestBid } from './AdminActions/AcceptHighestBid';
import { ReservePrice } from './AdminActions/ReservePrice';
import { useIsAlternativeAuction, useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { auctionOfferStatuses } from 'utils/statusCalculator';
import { useCurrentUser } from 'hooks/selectors';
import { ADMIN_VEHICLE_STATUS, VEHICLE_STATUSES } from 'constants';
import { AdminTopOffer } from './AdminActions/TopOffer';
import { SellerAcceptedPublicOffer } from './AdminActions/SellerAcceptedPublicOffer';
import { PublicOfferCounters } from './AdminActions/PublicOfferCounters';
import moment from 'moment';
import { PrivateOfferCounters } from './AdminActions/PrivateOfferCounters';
import { CounterHighestBid } from './AdminActions/CounterHighestBid';
import { BuyerAlternativeOffer, SellerAlternativeOffer } from './AdminActions/AlternativeAuctionOffers';
import { RelistVehicleBlock } from './PullVehicleControls/RelistBlock';
import { StopNegotiation } from './AdminActions/StopNegotiation';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 22px;
`;

export const AdminActions = () => {
  const vehicle = useViewedVehicle();

  if (!vehicle) return null;

  return (
    <InfoBlock>
      <RenderControls vehicle={vehicle} />
    </InfoBlock>
  );
};

type Props = {
  vehicle: Vehicle;
};

const RenderControls = ({ vehicle }: Props) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);
  const user = useCurrentUser();
  const status = auctionOfferStatuses(vehicle, offerAuction, user);
  const isAlternativeAuction = useIsAlternativeAuction(vehicle);

  const isAaTimerEnded = vehicle.date_end && moment.utc(vehicle.date_end).isBefore(moment.utc());

  if (vehicle.status === VEHICLE_STATUSES.DRAFT) return null;

  if (isAlternativeAuction && VEHICLE_STATUSES.ACTIVE === vehicle.status) {
    return (
      <Wrapper>
        {![VEHICLE_STATUSES.AWARDED, VEHICLE_STATUSES.DEACTIVATED].includes(vehicle.status) && <PullVehicleControls />}
        <ReservePrice vehicle={vehicle} />
        <SellerAlternativeOffer vehicle={vehicle} />
        <BuyerAlternativeOffer vehicle={vehicle} />
      </Wrapper>
    );
  }

  if (status === ADMIN_VEHICLE_STATUS.SELLER_ACCEPTED) {
    return (
      <Wrapper>
        <PullVehicleControls />
        {vehicle.buyer_id ? <AcceptHighestBid /> : <HighestBid />}
        <AdminTopOffer vehicle={vehicle} />
        <SellerAcceptedPublicOffer vehicle={vehicle} />
        <ReservePrice vehicle={vehicle} />
      </Wrapper>
    );
  }

  if (
    status === ADMIN_VEHICLE_STATUS.SELLER_COUNTERED ||
    status === ADMIN_VEHICLE_STATUS.BUYER_NOT_COUNTERED ||
    status === ADMIN_VEHICLE_STATUS.PUBLIC_ADMIN_COUNTER_SENT ||
    status === ADMIN_VEHICLE_STATUS.SELLER_NOT_COUNTERED
  ) {
    return (
      <Wrapper>
        <PullVehicleControls />
        <HighestBid />
        <ReservePrice vehicle={vehicle} />
        <AdminTopOffer vehicle={vehicle} />
        <PublicOfferCounters vehicle={vehicle} />
      </Wrapper>
    );
  }

  if (vehicle.status === VEHICLE_STATUSES.AWARDED) {
    // todo: awarded block
    return null;
  }

  if (vehicle.status === VEHICLE_STATUSES.DEACTIVATED) {
    return (
      <Wrapper>
        <RelistVehicleBlock />
      </Wrapper>
    );
  }

  if (vehicle.status === VEHICLE_STATUSES.PULLED) {
    return (
      <Wrapper>
        <PullVehicleControls />
      </Wrapper>
    );
  }

  if (!isAaTimerEnded) {
    return (
      <Wrapper>
        <PullVehicleControls />
        <ReservePrice vehicle={vehicle} />
      </Wrapper>
    );
  }

  const renderStopNegotiation =
    [
      ADMIN_VEHICLE_STATUS.BUYER_COUNTER_SENT,
      ADMIN_VEHICLE_STATUS.SELLER_COUNTER_SENT,
      ADMIN_VEHICLE_STATUS.ADMIN_COUNTER_SENT
    ].includes(status) &&
    offerAuction?.status === OfferAuctionStatus.PRIVATE_BIDS &&
    offerAuction?.privateOffers?.length > 0;

  return (
    <Wrapper>
      <PullVehicleControls />
      {renderStopNegotiation && <StopNegotiation vehicle={vehicle} />}
      {!vehicle.buyer_id && <HighestBid />}
      <ReservePrice vehicle={vehicle} />
      <AdminTopOffer vehicle={vehicle} />
      <PrivateOfferCounters vehicle={vehicle} />
      <CounterHighestBid vehicle={vehicle} />
      {/* {[
        ADMIN_VEHICLE_STATUS.BUYER_COUNTER_SENT,
        ADMIN_VEHICLE_STATUS.SELLER_COUNTER_SENT,
        ADMIN_VEHICLE_STATUS.ADMIN_COUNTER_SENT
      ].includes(status) &&
        offerAuction?.status === OfferAuctionStatus.PRIVATE_BIDS &&
        offerAuction?.privateOffers?.length > 0 && <StopNegotiationBlock vehicle={vehicle} />} */}
      {/* {![VEHICLE_STATUSES.PULLED, VEHICLE_STATUSES.AWARDED, VEHICLE_STATUSES.DEACTIVATED].includes(vehicle.status) &&
        isAaTimerEnded &&
        !vehicle.buyer_id && <HighestBidBlock {...props} />}
      <ReservePriceSection vehicle={vehicle} />
      <Grid item xs={12}>
        <StyledDivider />
      </Grid>
      {![VEHICLE_STATUSES.PULLED, VEHICLE_STATUSES.AWARDED, VEHICLE_STATUSES.DEACTIVATED].includes(vehicle.status) &&
        isVehicleTimerEnded &&
        vehicle.buyer_id && <AcceptedHighestBidBlock {...props} />}
      {vehicle.status === VEHICLE_STATUSES.ACTIVE && !isAlternativeAuction && (
        <AdminTopOfferBlock offerAuction={offerAuction} />
      )}
      {![VEHICLE_STATUSES.PULLED, VEHICLE_STATUSES.AWARDED, VEHICLE_STATUSES.DEACTIVATED].includes(vehicle.status) &&
        isVehicleTimerEnded &&
        !isAlternativeAuction && <CounterBidBlock {...props} isVehicleTimerEnded={isVehicleTimerEnded} />} */}
    </Wrapper>
  );
};

// TODO: stop negotiation block
